const galleryStatic = [
  { src: '/image1.JPG', alt: 'Domigo pet moment 1' },
  { src: '/image2.JPG', alt: 'Domigo pet moment 2' },
  { src: '/image3.JPG', alt: 'Domigo pet moment 3' },
  { src: '/image4.jpg', alt: 'Domigo pet moment 4' },
  { src: '/image1.JPG', alt: 'domigo pet moment 5'},
  { src: '/IMG_9484.jpg', alt: 'Domigo pet moment 6' },
   { src: '/IMG_0461.JPG', alt: 'Domigo pet moment 7' },
  { src: '/IMG_0658.JPG', alt: 'Domigo pet moment 8' },
  { src: '/98187.jpeg', alt: 'Domigo pet moment 9' },
  { src: '/114096.jpeg', alt: 'Domigo pet moment 10' },
 
];

export default galleryStatic;
